var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDots = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3231.195 -975)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  transform: "translate(3231.195 975)",
  fill: "#8798ad",
  opacity: 0
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3232,5.5a1.5,1.5,0,0,1,1.5-1.5,1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5A1.5,1.5,0,0,1-3232,5.5Z",
  transform: "translate(6473.695 981.5)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3232,5.5a1.5,1.5,0,0,1,1.5-1.5,1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5A1.5,1.5,0,0,1-3232,5.5Z",
  transform: "translate(6473.695 976.5)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3232,5.5a1.5,1.5,0,0,1,1.5-1.5,1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5A1.5,1.5,0,0,1-3232,5.5Z",
  transform: "translate(6473.695 986.5)",
  fill: "currentColor"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDots, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dots.810aecd3.svg";
export { ForwardRef as ReactComponent };